import styled from 'styled-components';

export const EndFrameWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    background: black;
    z-index: 10;

    .focus-visible {
        outline: none;
    }

    .video-in-video {
        display: flex;
    }
`;

export const EndFrameDiv = styled.div``;
